<template>
  <section class="embed">
    <p v-if="loadingMsg">{{ loadingMsg }}</p>
    <template v-else>
      <component
        v-if="selectedComponent"
        :is="selectedComponent"
        v-bind="componentProps"
      />
      <p v-else>
        Bad URL
      </p>
    </template>
    <a href="https://homicides.news.baltimoresun.com/" target="_top">See more »</a>
  </section>
</template>

<script>
import VictimLoader from "../mixins/VictimLoader.vue";

import CauseChart from "./CauseChart.vue";
import DistrictChart from "./DistrictChart.vue";
import TrendChart from "./TrendChart.vue";

export default {
  name: "ChartEmbed",
  components: {
    CauseChart,
    DistrictChart,
    TrendChart
  },
  mixins: [VictimLoader],
  data() {
    let curYear = String(new Date().getFullYear());
    // Get the component name from ?embed= in URL
    let componentName = window.location.search.match(/embed=([^&]+)/);
    componentName = componentName ? componentName[1] : "";
    return {
      componentName,
      currentYear: curYear,
      year: curYear
    };
  },
  computed: {
    selectedComponent() {
      return {
        cause: CauseChart,
        district: DistrictChart,
        trends: TrendChart
      }[this.componentName];
    },
    componentProps() {
      return {
        cause: {
          year: this.currentYear,
          allVictims: this.allVictims
        },
        district: {
          year: this.currentYear,
          allVictims: this.allVictims
        },
        trends: {
          currentYear: this.currentYear,
          allVictims: this.allVictims,
          trendLength: 10
        }
      }[this.componentName];
    }
  }
};
</script>

<style lang="scss" scoped="">
$gray: rgba(0, 0, 0, 0.4);

.embed {
  color: $gray;
  background-color: white;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;

  a {
    position: absolute;
    bottom: 0;
    right: 0;
    color: $gray;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.embed .legend-list {
  font-size: 14px;
}
</style>
